<template>
  <div>
    <el-form
      :model="form"
      :inline="true"
      size="mini"
      label-width="100px"
      class="hidden-xl-only"
    >
      <el-form-item style="float: right">
        <el-link
          type="primary"
          :underline="false"
          @click="collapse = !collapse"
          style="margin-right: 10px"
          >{{ collapse ? "折叠" : "展开" }}</el-link
        >
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-switch
          v-model="dataRange"
          active-text="全部"
          inactive-text="近半年"
          @change="switchType"
          style="margin-right: 15px; padding-left: 10px"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="店铺">
        <el-select v-model="form.storeCode" @change="storeCodeChange" filterable placeholder="全部">
          <el-option
            v-for="item in useObjectList"
            :label="item.name"
            :key="item.code"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大型号" prop="bigModel">
        <el-autocomplete
          class="form-input"
          v-model.trim="form.bigModel"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(2)"
          
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="小型号" prop="smallModel">
        <el-autocomplete
          class="form-input"
          v-model.trim="form.smallModel"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(3)"
          
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="类别">
        <el-autocomplete
          class="form-input"
          v-model.trim="form.category"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(0)"
          
        ></el-autocomplete>
      </el-form-item>
      <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse">
          <el-popover
            placement="top-start"
            title="常用选项"
            width="auto"
            trigger="hover"
          >
            <el-row>
              <el-col>
                <el-button type="primary" @click="searchName('近一周')"
                  >近一周</el-button
                >
                <el-button type="primary" @click="searchName('近30天')"
                  >近30天</el-button
                >
                <el-button type="primary" @click="searchName('近半年')"
                  >近半年</el-button
                >
                <el-button
                  type="primary"
                  @click="searchName('近一年')"
                  v-if="!timeType"
                  >近一年</el-button
                >
                <!-- <el-button
              type="primary"
              v-for="item in palyTime"
              @click="searchName(item)"
              :key="item"
              >{{ item }}</el-button
            > -->
              </el-col>
            </el-row>
            <span class="form-date-picker" slot="reference">
              <el-form-item label="时间:">
                <el-date-picker
                  v-model="form.startDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :clearable="timeType ? false : true"
                  :editable="timeType ? false : true"
                  :picker-options="timeType ? pickerOptions : timeNone"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="至" class="date-picker-middle">
                <el-date-picker
                  v-model="form.endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :clearable="timeType ? false : true"
                  :editable="timeType ? false : true"
                  :picker-options="timeType ? pickerOptions : timeNone"
                ></el-date-picker>
              </el-form-item>
            </span>
          </el-popover>
          <el-form-item label="颜色">
            <el-autocomplete
              class="form-input"
              v-model.trim="form.color"
              :fetch-suggestions="querySkuList"
              @focus="onSkuCodeFocus(1)"
            ></el-autocomplete>
          </el-form-item>
        </div>
      </transition>
    </el-form>
    <el-form
      :model="form"
      :inline="true"
      size="mini"
      label-width="100px"
      class="hidden-lg-and-down"
    >
      <el-form-item style="float: right">
        <!-- <el-link
          type="primary"
          :underline="false"
          @click="collapse = !collapse"
          style="margin-right: 10px"
          >{{ collapse ? "折叠" : "展开" }}</el-link
        > -->
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" @click="onReset">重置</el-button>
      </el-form-item>
      <el-form-item label="">
        <el-switch
          v-model="dataRange"
          active-text="全部"
          inactive-text="近半年"
          @change="switchType"
          style="margin-right: 15px; padding-left: 10px"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="店铺">
        <el-select v-model="form.storeCode" @change="storeCodeChange" filterable placeholder="全部">
          <el-option
            v-for="item in useObjectList"
            :label="item.name"
            :key="item.code"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="大型号" prop="bigModel">
        <el-autocomplete
          class="form-input"
          v-model.trim="form.bigModel"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(2)"
          
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="小型号" prop="smallModel">
        <el-autocomplete
          class="form-input"
          v-model.trim="form.smallModel"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(3)"
          
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="类别">
        <el-autocomplete
          class="form-input"
          v-model.trim="form.category"
          :fetch-suggestions="querySkuList"
          @blur="getCategoryMappingBigModel(true)"
          @focus="onSkuCodeFocus(0)"
          
        ></el-autocomplete>
      </el-form-item>
      <el-popover
        placement="top-start"
        title="常用选项"
        width="auto"
        trigger="hover"
      >
        <el-row>
          <el-col>
            <!-- <el-button
              type="primary"
              v-for="(item,index) in palyTime"
              @click="searchName(item)"
              :key="index"
              >{{ item }}</el-button
            > -->
            <el-button type="primary" @click="searchName('近一周')"
              >近一周</el-button
            >
            <el-button type="primary" @click="searchName('近30天')"
              >近30天</el-button
            >
            <el-button type="primary" @click="searchName('近半年')"
              >近半年</el-button
            >
            <el-button
              type="primary"
              @click="searchName('近一年')"
              v-if="!timeType"
              >近一年</el-button
            >
          </el-col>
        </el-row>
        <span class="form-date-picker" slot="reference">
          <el-form-item label="时间:">
            <el-date-picker
              v-model="form.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              :clearable="timeType ? false : true"
              :editable="timeType ? false : true"
              :picker-options="timeType ? pickerOptions : timeNone"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="至" class="date-picker-middle">
            <el-date-picker
              v-model="form.endDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :clearable="timeType ? false : true"
              :editable="timeType ? false : true"
              :picker-options="timeType ? pickerOptions : timeNone"
            ></el-date-picker>
          </el-form-item>
        </span>
      </el-popover>
      <!-- <transition name="el-zoom-in-top">
        <div v-if="collapse" class="search-header-collapse"> -->
      <el-form-item label="颜色">
        <el-autocomplete
          class="form-input"
          v-model.trim="form.color"
          :fetch-suggestions="querySkuList"
          @focus="onSkuCodeFocus(1)"
        ></el-autocomplete>
      </el-form-item>
      <!-- </div>
      </transition> -->
    </el-form>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
import { debounce } from "@/utils/index";
import moment from "moment";
export default {
  model: {
    prop: "formData",
    event: "input",
  },
  props: ["formData"],
  data() {
    return {
      collapse: false,
      form: {
        startDate: moment(new Date())
          .subtract(6, "months")
          .format("YYYY-MM-DD"),
        endDate: moment(new Date()).subtract("months").format("YYYY-MM-DD"),
      },
      useObjectList: [],
      categoryList: [],
      optionsn: [],
      inputData: [],
      dataRange: false,
      timeNone: {},
      disabled: false,
      inputIndex: 9,
      pickerOptions: {
        //disabled为函数，返回值为布尔值，
        disabledDate: (time) => {
          var curDate = new Date().getTime();
          var halfYear = (365 / 2) * 24 * 3600 * 1000;
          var pastResult = curDate - halfYear;
          var pastDate = new Date(pastResult),
            pastYear = pastDate.getFullYear(),
            pastMonth = pastDate.getMonth() + 1,
            pastDay = new Date().getDate();
          var minYear = pastYear + "-" + pastMonth + "-" + pastDay;
          if (this.timeType) {
            return (
              time > Date.now() ||
              time.getTime() < new Date(JSON.stringify(minYear))
            );
          } else {
            return;
          }
        },
      },
      pullDownLinkage: [],
    };
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
    collapse(val) {
      this.$emit("onCollapse", val);
    },
    $route: {
      handler(val, olv) {
        if (olv.path == "/ComprehensiveQuery" && val.query.bigModel) {
          this.$set(this.form, "bigModel", this.$route.query.bigModel);
          this.$set(this.form, "category", this.$route.query.categoryName);
          this.$set(this.form, "color", this.$route.query.color);
          this.$route.query.payTimeStart
            ? this.$set(this.form, "startDate", this.$route.query.payTimeStart)
            : this.$set(
                this.form,
                "startDate",
                moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
              );
          this.$route.query.payTimeEnd
            ? this.$set(this.form, "endDate", this.$route.query.payTimeEnd)
            : this.$set(
                this.form,
                "endDate",
                moment(new Date()).subtract("months").format("YYYY-MM-DD")
              );
          let data = {
            categoryName: this.form.category,
            smallModel: this.form.smallModel,
            bigModel: this.form.bigModel,
          };
          this.getDataRange();
          this.getOptionsn(data);
          this.queryCategory();
          this.salesGetStore();
        }
      },
    },
  },
  computed: {
    timeType() {
      if (
        !this.dataRange &&
        this.form.startDate <
          moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
      ) {
        this.$set(
          this.form,
          "startDate",
          moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
        );
        return true;
      } else if (
        !this.dataRange &&
        this.form.startDate <=
          moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
      ) {
        return true;
      } else if (this.dataRange) {
        return false;
      } else {
        return true;
      }
    },
    colorList() {
      let data = ["灰色", "米色", "蓝色", "咖色"];
      return data;
    },
    palyTime() {
      let data = ["近一周", "近30天", "近半年", "近一年"];
      return data;
    },
  },
  mounted() {
    this.$set(this.form, "bigModel", this.$route.query.bigModel);
    this.$set(this.form, "category", this.$route.query.categoryName);
    this.$set(this.form, "color", this.$route.query.color);
    this.$route.query.payTimeStart
      ? this.$set(this.form, "startDate", this.$route.query.payTimeStart)
      : this.$set(
          this.form,
          "startDate",
          moment(new Date()).subtract(6, "months").format("YYYY-MM-DD")
        );
    this.$route.query.payTimeEnd
      ? this.$set(this.form, "endDate", this.$route.query.payTimeEnd)
      : this.$set(
          this.form,
          "endDate",
          moment(new Date()).subtract("months").format("YYYY-MM-DD")
        );
    let data = {
      categoryName: this.form.category,
      smallModel: this.form.smallModel,
      bigModel: this.form.bigModel,
    };
    this.getDataRange();
    this.getOptionsn(data);
    this.queryCategory();
    this.salesGetStore();
  },
  methods: {
    onSearch() {
      if (!this.form.storeCode) {
        this.$message.error("店铺信息未选择，请填写后再搜索");
        return;
      } else if (!this.form.bigModel && !this.form.smallModel) {
        this.$message.error("型号信息未填写，请填写后再搜索");
        return;
      } else if (!this.form.startDate || !this.form.endDate) {
        this.$message.error("时间信息未填写，请填写后再搜索");
        return;
      } else if (!this.form.category) {
        this.$message.error("类别信息未填写，请填写后再搜索");
        return;
      }

      this.$set(this.form, "chartStoreCode", this.formData.storeCode);
      this.$emit("search", this.form);
    },
    onReset() {
      this.form = {
        storeCode: this.form.storeCode,
        startDate: moment(new Date())
          .subtract(6, "months")
          .format("YYYY-MM-DD"),
        endDate: moment(new Date()).subtract("months").format("YYYY-MM-DD"),
      };
      this.getOptionsn()
      this.$emit("reset");
    },

    searchName(item) {
      let week = moment(new Date())
        .subtract(1, "weeks")
        .subtract(-1, "days")
        .format("YYYY-MM-DD");
      let day = moment(new Date())
        .subtract(30, "days")
        .subtract(-1, "days")
        .format("YYYY-MM-DD");
      let month = moment(new Date()).subtract(6, "months").format("YYYY-MM-DD");
      let year = moment(new Date()).subtract(1, "years").format("YYYY-MM-DD");
      let time = moment(new Date()).subtract("months").format("YYYY-MM-DD");
      if (item == "近一周") {
        this.$set(this.form, "startDate", week);
      } else if (item == "近30天") {
        this.$set(this.form, "startDate", day);
      } else if (item == "近半年") {
        this.$set(this.form, "startDate", month);
      } else {
        this.$set(this.form, "startDate", year);
      }
      this.$set(this.form, "endDate", time);
    },

    getDataRange() {
      this.$q.intelligentRecom.getDataRange({}).then((res) => {
        res.data == "Y" ? (this.dataRange = true) : (this.dataRange = false);
      });
    },
    switchType() {
      let params = {
        params: {
          dataRange: this.dataRange ? "Y" : "N",
        },
      };
      this.$q.intelligentRecom.updateDataRange({ params }).then((res) => {});
    },

    getCategoryMappingBigModel(type) {
      setTimeout(_=>{
        let data = {
        categoryName: this.form.category,
        smallModel: this.form.smallModel,
        bigModel: this.form.bigModel,
        };
      this.getOptionsn(data);
      },type ? 200 : 0)
    },
    onSkuCodeFocus(index) {
      this.inputIndex = index
      if (index == 0) {
        this.inputData = this.optionsn.category;
      } else if (index == 1) {
        this.inputData = this.optionsn.color;
      } else if (index == 2) {
        this.inputData = this.optionsn.bigModel;
      } else if (index == 3) {
        this.inputData = this.optionsn.smallModel;
      }
    },

    queryStringFales(queryString,cb) {
      let data = {
        categoryName: this.form.category,
        smallModel: this.form.smallModel,
        bigModel: this.form.bigModel,
        };
      this.$q.intelligentRecom
        .optionsn({ data: data})
        .then((res) => {
          this.optionsn = res.data;
          if (this.inputIndex == 0) {
          this.inputData = this.optionsn.category;
        }else if(this.inputIndex == 2) {
          this.inputData = this.optionsn.bigModel;
        }else if(this.inputIndex == 3) {
          this.inputData = this.optionsn.smallModel;
        } 
        let data = this.inputData;
        if (!data || !data.allOptions) {
          cb([]);
          return;
        }
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.allOptions
        ? data.allOptions
            .filter((v) => !v.useFlag)
            .map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      console.log(results);
      // 调用 callback 返回建议列表的数据
      cb(results);
        })
        .finally((_) => {
          
        });
    },

    queryStringTrue(queryString, cb) {
      let data = this.inputData;
      if (!data || !data.allOptions) {
        cb([]);
        return;
      }
      let results = queryString
        ? data.allOptions
            .map((v) => v.criteriaContent)
            .filter((item) =>
              item.toLowerCase().includes(queryString.toLowerCase())
            )
        : data.allOptions
        ? data.allOptions
            .filter((v) => !v.useFlag)
            .map((v) => v.criteriaContent)
        : [];
      if (!results || !results.length) {
        cb([]);
        return;
      }
      if (this.inputIndex == 0) {
        this.optionsn.bigModel = []
        this.optionsn.smallModel = []
        this.getCategoryMappingBigModel();
      }else if(this.inputIndex == 2 && queryString && queryString.length>2) {
        this.optionsn.smallModel = []
        this.getCategoryMappingBigModel();
      }else if(this.inputIndex == 3 && queryString && queryString.length>2) {
        this.optionsn.bigModel = []
        this.getCategoryMappingBigModel();
      } 
      results = results.map((item) => ({
        ...item,
        value: item,
      }));
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

     querySkuList(queryString, cb) {
      if(queryString) {
        this.queryStringTrue(queryString, cb)
      }else {
        this.queryStringFales(queryString, cb)
      }
    },
    salesGetStore() {
      this.$q.intelligentRecom.getStore({}).then((res) => {
        this.useObjectList = res.data;
        if (res.data[0].whetherDef == "1") {
          this.$set(this.form, "storeCode", res.data[0].code);
          this.$emit('getMainModel',this.form.storeCode)
        }
      });
    },
    storeCodeChange() {
      this.$emit('getMainModel',this.form.storeCode)
    },

    getOptionsn(data) {
      this.disabled = true;
      this.$q.intelligentRecom
        .optionsn({ data: data || {} })
        .then((res) => {
          this.optionsn = res.data;
        })
        .finally((_) => {
          this.disabled = false;
        });
    },
    queryCategory() {
      const params = {
        categoryName: this.$route.query.bigModel,
      };
      this.$q.intelligentRecom.queryCategory(params).then((res) => {
        this.categoryList = res.data;
        if (this.$route.query.bigModel) {
          this.$emit("search", this.form);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
>>> .el-form {
  width: 100%;
  margin-top: 10px;
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

>>> .el-form-item__label {
  width: 60px !important;
}

.search-header-collapse {
  // position absolute
  background-color: #ffffff;
  width: 100%;
  left: 0px;
  padding: 5px 0px 0px 0;
  margin-top: -5px;
  box-sizing: border-box;
  // z-index 999
  // box-shadow 0px 5px 5px rgba(0,0,0,.1)
}

>>> .table-input input {
  height: 18px;
  line-height: 18px;
  padding: 0 10px;
  text-align: right;
  width: 45px;
}

>>> .form-date-picker .el-date-editor {
  width: 128px !important;
}

>>> .el-autocomplete .el-input__inner {
  width: 130px;
}

>>> .el-form .el-input {
  width: 130px;
}

>>> .el-form .el-select {
  width: 130px;
}
</style>